<template>
  <section>
    <div class="modal is-clipped" :class="{'is-active': displayUpgradeAccountComponent}">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Upgrade Account</p>
          <button class="delete" aria-label="close" @click="displayUpgradeAccountComponent=false"></button>
        </header>
        <section class="modal-card-body">
          <div class="pricing-table">
            <div class="pricing-plan is-link">
              <div class="plan-header">MileLogix</div>
              <div class="plan-header">Annual Plan</div>

              <div class="plan-price">
                <span class="plan-price-amount">
                  <span class="plan-price-currency">$</span>5
                </span>/month/user
              </div>
              <div class="plan-items">
                <div class="plan-item">Calendar based mileage tracking</div>
                <div class="plan-item">
                  Blazing
                  <i>fast</i> report generation
                </div>
                <div class="plan-item">HIPAA Compliant</div>
                <div class="plan-item">Supports any exported calendar file</div>
                <div class="plan-item">No cancellation fees</div>
              </div>
              <div class="plan-footer">
                <button class="button is-medium" @click="checkout('annual')">Upgrade</button>
              </div>
            </div>

            <div class="pricing-plan is-link">
              <div class="plan-header">MileLogix</div>
              <div class="plan-header">Monthly Plan</div>

              <div class="plan-price">
                <span class="plan-price-amount">
                  <span class="plan-price-currency">$</span>8
                </span>/month/user
              </div>
              <div class="plan-items">
                <div class="plan-item">Calendar based mileage tracking</div>
                <div class="plan-item">
                  Blazing
                  <i>fast</i> report generation
                </div>
                <div class="plan-item">HIPAA Compliant</div>
                <div class="plan-item">Supports any exported calendar file</div>
                <div class="plan-item">No cancellation fees</div>
              </div>
              <div class="plan-footer">
                <button class="button is-medium" @click="checkout('monthly')">Upgrade</button>
              </div>
            </div>
          </div>
          <p class="help is-danger" v-if="error.payment">Error processing payment. Please try again.</p>
        </section>
      </div>
    </div>
    <vue-stripe-checkout
      ref="checkoutRef"
      :name="name"
      :description="description"
      :currency="currency"
      :amount="amount"
      :allow-remember-me="false"
      :zip-code="true"
      :email="email"
      @done="done"
      @opened="opened"
      @closed="closed"
      @canceled="canceled"
    ></vue-stripe-checkout>
  </section>
</template>

<script>
import Vue from "vue";
import VueStripeCheckout from "vue-stripe-checkout";
import { setTimeout } from "timers";
import EventBus from "../event-bus";

Vue.use(VueStripeCheckout, process.env.VUE_APP_STRIPE_PUB_KEY);

export default {
  data() {
    return {
      name: "ABALogix LLC",
      description: undefined,
      currency: "usd",
      amount: undefined,
      email: undefined,
      subscriptionType: undefined,
      error: {
        payment: false
      },
      displayUpgradeAccountComponent: false
    };
  },
  mounted: function() {
    EventBus.$on("displayUpgradeAccount", eventData => {
      this.displayUpgradeAccountComponent = eventData;
    });
  },
  methods: {
    checkout(subscriptionType) {
      switch (subscriptionType) {
        case "annual":
          this.subscriptionType = subscriptionType;
          this.amount = 500 * 12; //Set for Stripe Checkout display purposes *only*
          this.description = "Annual MileLogix Subscription";
          break;

        case "monthly":
          this.subscriptionType = subscriptionType;
          this.amount = 800; //Set for Stripe Checkout display purposes *only*
          this.description = "Monthly MileLogix Subscription";
          break;
      }
      setTimeout(() => this.$refs.checkoutRef.open());
    },
    done({ token }) {
      // Reset amounts to pass to /payment endpoint
      let stripeTransactionData = {
        token_id: token.id,
        subscription_type: this.subscriptionType
      };
      this.$http
        .post(process.env.VUE_APP_API_URL + "/upgrade", stripeTransactionData)
        .then(
          setTimeout(() => {
            this.displayUpgradeAccountComponent = false;
            this.$emit("display-component", "upload");
          }, 5000)
        )
        .catch(function() {
          this.error.payment = true;
        });
    },
    opened() {},
    closed() {},
    canceled() {}
  }
};
</script>


<style lang="sass" scoped>
@import "bulma/bulma.sass"
@import "bulma-pricingtable/dist/css/bulma-pricingtable.sass"
</style>
